import { render, staticRenderFns } from "./sizingWidget.vue?vue&type=template&id=fd35ed52&shadow"
import script from "./sizingWidget.vue?vue&type=script&lang=js&shadow"
export * from "./sizingWidget.vue?vue&type=script&lang=js&shadow"
function injectStyles (context) {
  
  
}

/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  ,true
)

export default component.exports